import React, { useState } from "react";
import "./Forms.css";

import FormHeading, {
  CancelButton,
  FormButtons,
  PickTime,
  ScheduledInfo,
  SubmitButton,
  SubmittedBox,
} from "../FormComponents/FormComponents";
import CustomCalendar from "../Calendar/CustomCalendar";
import axios from "axios";
import { api_link } from "../../config";
import config from "../../config";
import { useNavigate } from "react-router-dom";

export default function ScheduleDemo({ setStep }) {
  const REACT_APP_AUTH_URL = config.auth.REACT_APP_AUTH_URL;
  const [dateSelected, setDateSelected] = useState(new Date());
  const [timeSelected, setTimeSelected] = useState("");
  const [timeZoneSelected, setTimeZoneSelected] = useState("");
  const [durationSelected, setDurationSelected] = useState("15min");
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  // Convert time into 24H format
  const convertTo24HourFormat = (time) => {
    const [timePart, modifier] = time.split(" ");
    let [hours, minutes] = timePart.split(":").map(Number);

    if (modifier === "PM" && hours < 12) hours += 12;
    if (modifier === "AM" && hours === 12) hours = 0;

    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const submitData = async () => {
    const formData = JSON.parse(sessionStorage.getItem("formData")) || {};
    const storedQaList = JSON.parse(sessionStorage.getItem("qaList")) || [];

    // Update question names if needed
    if (storedQaList[0]) {
      storedQaList[0].question = "which_industry_best_describes_your_organization_";
    }
    if (storedQaList[1]) {
      storedQaList[1].question = "what_segment_best_categorizes_your_organization_";
    }
    if (storedQaList[2]) {
      storedQaList[2].question = "where_is_your_organization_in_its_journey_with_vision_ai_and_edge_ai_";
    }
    if (storedQaList[3]) {
      storedQaList[3].question = "select_your_primary_focus_area_s__for_vision_ai_and_edge_ai_applications";
    }
    if (storedQaList[4]) {
      storedQaList[4].question = "how_does_your_organization_currently_generate_insights_from_visual_data_";
    }
    if (storedQaList[5]) {
      storedQaList[5].question = "what_data_sources_would_you_need_to_integrate_with_computer_vision_solution_";
    }
    if (storedQaList[6]) {
      storedQaList[6].question = "what_does_success_with_computer_vision_look_like_for_your_organization_";
    }

    // Define required fields and remove unnecessary keys
    const removeKeys = ["name", "companyName", "jobTitle", "team", "country"];
    const requiredFields = {
      company: formData.companyName || "",
      full_name: formData.name || "",
      country_dropdown: formData.country || "",
      jobtitle: formData.jobTitle || "",
      department___team: formData.team || "",
    };

    const updatedFormData = Object.fromEntries(
      Object.entries({ ...formData, ...requiredFields }).filter(([key]) => !removeKeys.includes(key))
    );

    // Create question-answer object
    const qaObject = storedQaList.reduce((acc, item) => {
      acc[item.question] = item.answer || "";
      return acc;
    }, {});

    const formDataCombined = { ...updatedFormData, ...qaObject };
    const finalFormData = {
      fields: Object.entries(formDataCombined).map(([key, value]) => ({
        name: key,
        value: value,
      })),
    };

    // Log finalFormData for debugging
    console.log("Final FormData being sent to HubSpot:", finalFormData);

    try {
      // Send the main form data to HubSpot
      await axios.post(`${api_link}`, finalFormData);
    } catch (error) {
      console.error("Error submitting form data:", error.response?.data || error.message);
      navigate("/error");
      return;
    }

    // Meeting scheduling data preparation
    const formattedDate = `${dateSelected.getFullYear()}-${String(
      dateSelected.getMonth() + 1
    ).padStart(2, "0")}-${String(dateSelected.getDate()).padStart(2, "0")}`;
    const dateTime = `${formattedDate}T${convertTo24HourFormat(timeSelected)}`;
    const meetingData = {
      user_email: formData.email,
      date_time: dateTime,
      time_zone: timeZoneSelected,
      duration: durationSelected.slice(0, -2),
    };

    try {
      // Send meeting scheduling data
      const response = await axios.post(`${REACT_APP_AUTH_URL}/v1/open/meeting`, meetingData);
      console.log("Meeting Data Submitted", response);
      setSubmitted(true);
    } catch (error) {
      console.error("Error submitting meeting data:", error.response?.data || error.message);
      navigate("/error");
      return;
    }

    sessionStorage.clear();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (timeSelected.charAt(0) === "N") {
      alert("No available time slots for the selected date.");
      return;
    }
    submitData();
  };

  return (
    <div className="schedule-demo-wrapper">
      <FormHeading h3="Schedule Demo" />
      <div className="schedule-demo-top">
        <div className="schedule-demo-left">
          <CustomCalendar setDateSelected={(date) => setDateSelected(date)} />
        </div>
        <div className="schedule-demo-right">
          <PickTime
            setTimeSelected={(time) => setTimeSelected(time)}
            setTimeZoneSelected={(timezone) => setTimeZoneSelected(timezone)}
            setDurationSelected={(duration) => setDurationSelected(duration)}
            selectedDate={dateSelected}
          />
        </div>
      </div>

      <div className="schedule-demo-bottom">
        <ScheduledInfo
          dateSelected={dateSelected}
          timeSelected={timeSelected}
          timeZoneSelected={timeZoneSelected}
        />
        <FormButtons>
          <CancelButton name="Back" onClick={() => setStep(2)} />
          <SubmitButton name="Schedule Demo" onClick={handleSubmit} />
        </FormButtons>
      </div>
      {submitted && (
        <SubmittedBox
          setStep={setStep}
          dateSelected={dateSelected}
          timeSelected={timeSelected}
          timeZoneSelected={timeZoneSelected}
        />
      )}
    </div>
  );
}
